export default __webpack_public_path__ + "static/logo-0e5438162297ef49ccb76e63d8ffca95.svg";